// Blog-only predictive search. Hits Shopify predictive search API restricted
// to articles and renders results from the predictive-search-blog section.
class BlogSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("[data-blog-search-input]");
    this.hiddenQuery = this.querySelector("[data-blog-search-q]");
    this.results = this.querySelector("[data-blog-search-results]");
    this.form = this.querySelector("form");
    this.cache = {};
    this.minChars = 2;
    this.bindEvents();
  }

  bindEvents() {
    this.input.addEventListener("input", this.debounce(this.onInput.bind(this), 300));
    this.input.addEventListener("focus", this.onInput.bind(this));
    document.addEventListener("click", this.onDocumentClick.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
  }

  get query() {
    return this.input.value.trim();
  }

  onInput() {
    const query = this.query;
    // Keep the hidden q in sync so native form submit reaches /search?q=...&type=article
    this.hiddenQuery.value = query;
    if (query.length < this.minChars) {
      this.close();
      return;
    }
    this.search(query);
  }

  search(query) {
    const key = query.toLowerCase();
    if (this.cache[key] !== undefined) {
      this.render(this.cache[key]);
      return;
    }
    const base = window.MinimogSettings.routes.predictive_search_url;
    const url = `${base}?q=${encodeURIComponent(query)}&resources[type]=article&section_id=predictive-search-blog`;
    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        const html = new DOMParser().parseFromString(text, "text/html");
        const section = html.querySelector("#shopify-section-predictive-search-blog");
        const markup = section ? section.innerHTML : "";
        this.cache[key] = markup;
        this.render(markup);
      })
      .catch(() => this.close());
  }

  render(markup) {
    this.results.innerHTML = markup;
    this.open();
  }

  open() {
    this.results.classList.remove("m:hidden");
    this.setAttribute("open", "true");
  }

  close() {
    this.results.classList.add("m:hidden");
    this.removeAttribute("open");
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) this.close();
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close();
  }

  debounce(fn, wait) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define("blog-search", BlogSearch);
